module.exports = __webpack_public_path__ + "static/media/coll-8-logistics.648e1116.png";